import {AsyncComponent} from '@modifi/code-splitting'
import PageLoader from '../../ui/page-loader'

export const PreviewBillingPage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "preview" */ './preview-billing'),
  loader: PageLoader,
})
export const PreviewOrdersPage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "preview" */ './preview-orders'),
  loader: PageLoader,
})
export const PreviewOverviewPage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "preview" */ './preview-overview'),
  loader: PageLoader,
})
export const PreviewReportsPage = AsyncComponent({
  importThunk: () => import(/* webpackChunkName: "preview" */ './preview-reports'),
  loader: PageLoader,
})
